<template>
  <div class="mb-3 device-status-title">即時狀態</div>
  <div class="device-status-bar" style="">
    <div
      v-for="(value, deviceStatus) in totalDeviceStatus"
      :keys="deviceStatus"
      class="device-status-bar-background"
      style=""
      :style="{
        background: value.color,
        'min-width': 'calc(100% * ' + value.value / deviceArrayLength + ')',
        height: 'calc(100% * ' + value.value / deviceArrayLength + ')',
        display: (value.value == 0 ? 'none' : 'flex') + '!important',
      }"
    >
      <template v-if="value.value > 0">
        <div class="device-status-bar-list">
          <div class="device-status-bar-name">
            {{ value.text }}
          </div>
          <div class="device-status-bar-value">
            {{ value.value }}
          </div>
        </div>
      </template>
    </div>
  </div>
  <div class="text-center device-status-icon-detail">
    <template
      v-for="(value, deviceStatus) in totalDeviceStatus"
      :keys="deviceStatus"
    >
      <template v-if="value.value > 0">
        <span class="pe-2 mb-2">
          <font-awesome-icon
            :icon="['fas', 'square']"
            :style="{
              color: value.color,
            }"
          />
          {{ value.text }}
        </span>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    totalDeviceStatus: Object,
    deviceArrayLength: Number,
  },
};
</script>

<style>
.device-status-bar {
  width: 48px;
  height: calc(100% - 40px);
  margin: 0 auto;
}
.device-status-bar-background {
  color: var(--main-font-color);
  min-height: 50px;
  width: 100% !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
.device-status-bar-name {
  display: block;
}
.device-status-icon-detail {
  display: none;
}

@media screen and (max-width: 1400px) {
  .device-status-title {
    display: none;
  }
  .device-status-bar {
    width: 100%;
    height: auto;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .device-status-bar-background {
    color: var(--main-font-color);
    height: 50px !important;
    min-width: 10px;
    width: 100% !important;
  }
  .device-status-bar-list {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    line-height: 50px;
    overflow-y: auto;
  }
  .device-status-bar-name {
    display: none;
    white-space: nowrap;
  }
  .device-status-bar-value {
    white-space: nowrap;
  }
  .device-status-icon-detail {
    display: block;
  }
}
</style>
